import React, { useState } from "react";
import "./FAQPage.css";

const FAQPage = () => {
  const [activeTab, setActiveTab] = useState("ase");
  const [expandedSection, setExpandedSection] = useState("section1");

  const faqData = {
    ase: {
      sections: [
        {
          id: "section1",
          title: "Scope and Eligibility",
          questions: [
            {
              question: "If an associate is not allocated to a project, can they enroll in Post-Onboard Learning?",
              answer:
                "Yes. ASEs who are on bench, shadow hard-lock, or soft-lock projects are eligible to register for the Post OB Learning Program.",
            },
            {
              question: "Can an associate enroll in a cluster if their role does not exactly match?",
              answer:
                "No. Associates with works with project should enroll only in clusters aligned with their confirmed project role to avoid skill mismatch. Associates on Bench , must select the cluster aligned to their stream of learning.",
            },
            {
              question: "Can I register for other schools or clusters later?",
              answer:
                "No. This is a role-based learning program. You can register only for the cluster and role relevant to your project. Those on Bench should select stream learning cluster.  Registration for other roles or clusters is not allowed.",
            },
            {
              question: "Is this training Mandatory for all trainees/ASEs?",
              answer: (
                <>
                  Yes, the training is <strong>Mandatory</strong> for all ASEs.
                </>
              ),
            },
            {
              question: "Does this comes under the Tech Lead Program or LTT?",
              answer: "This is an ATCI-level initiative, This is called Post On Board Learning Program mandatory for all ASEs.",
            },
            {
              question: "How long will this training be going on (in-months)?",
              answer: "The duration depends on the cluster and role and may extend from 12 to 18 months.",
            },
            {
              question: "If the candidate does not register now, is it mandatory to complete it later, or can it be skipped?",
              answer: "The training is mandatory and must be completed in the upcoming days.",
            },
            {
              question: "What is the expected outcome of the training apart from skill development?",
              answer: "This program makes you role-ready, AI-native & skill-proficient.",
            },
            {
              question: "Who will approve the nomination for on-bench associates?",
              answer: "For on-bench candidates, the Bench Manager will be the approver.",
            }  
          ],
        },
        {
          id: "section2",
          title: "School Selection",
          questions: [
            {
              question: "What should an associate do if there is no suitable learning cluster for their role?",
              answer: "As mentioned in the communication, the associate should write to the designated mailbox for guidance instead of enrolling in an unrelated cluster.",
            },
            {
              question: "How can I clear the form if I selected the wrong cluster or role?",
              answer: "Simply refresh the form to clear all the entered data.",
            },
          ],
        },
        {
          id: "section3",
          title: "Enrollment",
          questions: [
            {
              question: "What should an associate do if they realize after enrollment that the learning does not match their role?",
              answer: "The associate should immediately write to L-TT.Post.OBLearning@accenture.com for corrective action.",
            },
            {
              question: "I mistakenly selected “Not in Project” or chose the wrong cluster, and my nomination was auto-submitted. What should I do?",
              answer: "Please do not worry. The team is correcting this from the backend. You will be able to resubmit your nomination tomorrow (21st Jan 2026) once the correction is complete.",
            },
            {
              question: "When can ASEs nominate for the Post Onboard Learning Program?",
              answer: "ASEs can nominate only after receiving the invite from the Post Onboard Learning team. Attempting to nominate before this will show the error: “You are not eligible to nominate for Post Onboard Learning Cluster School 1.” Please wait to receive the registration email from L-TT.Post.OBLearning@accenture.com",
            }
          ],
        },
        {
          id: "section4",
          title: "Progress",
          questions: [
            {
              question: "In the same cluster, can we register for other schools after completing one school?",
              answer: "Yes. Currently, you will be automatically registered for School 1. After completing School 1, you will need to manually register for School 2, School 3, and School 4, as applicable.",
            },
            {
              question: "How much time do I have to contribute in a day ('in hours approx' or 'a full day training?",
              answer: "The training can be completed at the individual’s convenience; however, approximately one hour per day is recommended.",
            },
            {
              question: "Is the training trainer-led or self-paced?",
              answer: "It is a blended program that includes both self-paced modules and scheduled VILT sessions.",
            }
          ],
        }
        // {
        //   id: "section5",
        //   title: "Assessment",
        //   questions: [
        //     {
        //       question: "What types of assessments are included?",
        //       answer:
        //         "Assessments include knowledge checks, practical assignments, and project-based evaluations to measure your skill development and project readiness.",
        //     },
        //     {
        //       question: "When are assessments scheduled?",
        //       answer:
        //         "Assessment schedules are available in the Calendar section. You'll receive notifications before each assessment deadline.",
        //     },
        //   ],
        // },
      ],
    },
    supervisors: {
      sections: [
        {
          id: "section1",
          title: "Scope and Eligibility",
          questions: [
            {
              question: "What is my role as a Supervisor/Project Mentor?",
              answer:
                "As a supervisor or project mentor, you guide program participants, provide project context, and help align their learning with real-world project requirements.",
            },
            {
              question: "Who can I mentor in this program?",
              answer:
                "You can mentor employees onboarded after 15th October who are assigned to your project and enrolled in the Quantum Reinvent Program.",
            },
          ],
        },
        {
          id: "section2",
          title: "School Selection",
          questions: [
            {
              question: "How do I help mentees select the right school?",
              answer:
                "Guide them based on their project role, required skills, and career trajectory. Ensure the school aligns with current and upcoming project needs.",
            },
          ],
        },
        {
          id: "section3",
          title: "Enrollment",
          questions: [
            {
              question: "How do I verify my mentee's enrollment?",
              answer:
                "You can view your mentee's enrollment status through the supervisor dashboard or by contacting the program administrators.",
            },
          ],
        },
        {
          id: "section4",
          title: "Progress",
          questions: [
            {
              question: "How do I monitor mentee progress?",
              answer:
                "Access the supervisor dashboard to view real-time progress, completion rates, and upcoming milestones for all your mentees.",
            },
            {
              question: "What should I do if a mentee is struggling?",
              answer:
                "Schedule a one-on-one discussion to understand challenges, adjust workload if needed, and collaborate with DU Leads for additional support.",
            },
          ],
        },
        {
          id: "section5",
          title: "Assessment",
          questions: [
            {
              question: "What is my role in assessments?",
              answer:
                "Review project-based assessments, provide feedback on practical applications, and validate that learning outcomes align with project requirements.",
            },
          ],
        },
      ],
    },
  };

  const toggleSection = (sectionId) => {
    setExpandedSection(expandedSection === sectionId ? null : sectionId);
  };

  const currentData = faqData[activeTab];

  return (
    <div className="faq-page">
      {/* Hero Section */}
      <div
        className="faq-hero"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/Images/HomePage/FAQ-banner.png)`,
        }}
      >
        <div className="faq-hero__inner">
          <h1 className="faq-hero__title">FAQ</h1>
          <p className="faq-hero__subtitle">
            Know when to register, learn, and get assessed
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="faq-content">
        {/* Tabs */}
        <div className="faq-tabs">
          <button
            className={`faq-tab ${activeTab === "ase" ? "active" : ""}`}
            onClick={() => setActiveTab("ase")}
          >
            ASE's
          </button>
          <button
            className={`faq-tab ${activeTab === "supervisors" ? "active" : ""}`}
            onClick={() => setActiveTab("supervisors")}
          >
            Supervisors, Project Mentors, DU Leads
          </button>
        </div>

        {/* Content Area */}
        <div className="faq-main">
          {/* Sidebar */}
          <div className="faq-sidebar">
            {currentData.sections.map((section, index) => (
              <div
                key={section.id}
                className={`faq-section-item ${
                  expandedSection === section.id ? "active" : ""
                }`}
                onClick={() => toggleSection(section.id)}
              >
                <div className="faq-section-header">
                  <span className="faq-section-number">Section {index + 1}</span>
                  <span className="faq-section-dash"> - </span>
                  <span className="faq-section-title">{section.title}</span>
                </div>
                <span className="faq-section-arrow">›</span>
              </div>
            ))}
          </div>

          {/* FAQ Content */}
          <div className="faq-content-area">
            {currentData.sections.map((section) =>
              expandedSection === section.id ? (
                <div key={section.id} className="faq-questions">
                  {section.questions.map((item, index) => (
                    <div key={index} className="faq-item">
                      <h3 className="faq-question">{item.question}</h3>
                      <p className="faq-answer">{item.answer}</p>
                    </div>
                  ))}
                </div>
              ) : null
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQPage;
